import { GLBModel } from "@/scene/GLBModel";
import type { EnvironmentDecorItemConfig } from "@/scene/SceneProps";
import {
  CORAL_MODELS,
  LOG_MODEL,
  ROCK_FORMAT2_MODEL,
  ROCK_MODEL,
} from "./shared";
import { UnderwaterVisualSettingsOverride } from "@/scene/VisualSettings";

// Осьминог — Бытовой мусор: маска, футболка, носки
export const OCTOPUS_GARBAGE_MODELS = [
  new GLBModel("/models/garbage/mask_02.glb"),
  new GLBModel("/models/garbage/short02.glb"),
  new GLBModel("/models/garbage/socks_02.glb"),
];

export const OCTOPUS_ENVIRONMENT_DECOR: EnvironmentDecorItemConfig[] = [
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.78,
    position: { x: -3, y: -2.9, z: -1.15 },
    rotation: { x: 0, y: 0.42, z: 0 },
    scale: { x: 3.15, y: 2.3, z: 2.55 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.78,
    position: { x: -0.7, y: -3.25, z: -3.15 },
    rotation: { x: 0, y: -0.976, z: 0 },
    scale: { x: 3.15, y: 2.3, z: 4.3 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.78,
    position: { x: 1.8, y: -3.25, z: -2.97 },
    rotation: { x: 3.142, y: -0.944, z: 3.142 },
    scale: { x: 1.4, y: 2.3, z: 2.6 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.58,
    position: { x: 1.65, y: -2.28, z: -0.9 },
    rotation: { x: 0, y: -0.7, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 0.52,
    position: { x: 0.88, y: -2.29, z: 1.18 },
    rotation: { x: 0, y: 2.35, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: ROCK_MODEL,
    targetSize: 0.44,
    position: { x: -1.05, y: -2.3, z: 1.02 },
    rotation: { x: 0, y: 1.65, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 1.35,
    position: { x: -0.18, y: -2.28, z: 1.62 },
    rotation: { x: 0.04, y: -0.78, z: 0.06 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: 1, y: -2.55, z: -4.7 },
    rotation: { x: 0, y: 0.785, z: 0 },
    scale: { x: 1.9, y: 3.25, z: 2.05 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: -3.25, y: -2.55, z: -4.52 },
    rotation: { x: 0, y: 1.57, z: 0 },
    scale: { x: 1.9, y: 2.5, z: 1.25 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: -3.45, y: -2.55, z: 0.05 },
    rotation: { x: 0, y: 0.959, z: 0 },
    scale: { x: 1.9, y: 2.5, z: 1.25 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: 0.18, y: -2.28, z: 3 },
    rotation: { x: 0, y: -0.524, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: LOG_MODEL,
    targetSize: 2,
    position: { x: 0.2, y: -2.55, z: -1.65 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.9, y: 2.45, z: 1.45 },
  },
  {
    model: ROCK_FORMAT2_MODEL,
    targetSize: 1.07,
    position: { x: 2, y: -2.27, z: 2 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: CORAL_MODELS[5],
    targetSize: 0.7,
    position: { x: -2.8, y: -2.75, z: -2.2 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 2.3, y: 3.35, z: 1.95 },
  },
  {
    model: CORAL_MODELS[5],
    targetSize: 0.7,
    position: { x: 2.2, y: -2.6, z: -2.02 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 2.3, y: 4.75, z: 2.35 },
  },
  {
    model: CORAL_MODELS[5],
    targetSize: 0.7,
    position: { x: -1, y: -3, z: -5.05 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 2.3, y: 4.75, z: 2.35 },
  },
  {
    model: CORAL_MODELS[5],
    targetSize: 0.7,
    position: { x: -0.82, y: -3, z: -0.6 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.2, y: 2.4, z: 1 },
  },
  {
    model: CORAL_MODELS[6],
    targetSize: 0.7,
    position: { x: 0, y: -2.28, z: -4.3 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1, y: 1, z: 1 },
  },
  {
    model: CORAL_MODELS[3],
    targetSize: 0.7,
    position: { x: -2.75, y: -2.8, z: 0 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 1.3, y: 1.95, z: 1 },
  },
  {
    model: CORAL_MODELS[8],
    targetSize: 0.7,
    position: { x: -4.8, y: -2.28, z: -2 },
    rotation: { x: 0, y: 0, z: 0 },
    scale: { x: 2.85, y: 13.4, z: 4.3 },
  },
];

export const OCTOPUS_VISUAL_SETTINGS: UnderwaterVisualSettingsOverride = {
  pollutionColor: "#788265",
};